import {
    Component,
    Input,
    OnInit,
    TemplateRef,
    ViewChild
} from '@angular/core';
import { CartService } from '@services/cart.service';
import { ProductAttribute } from '@interfaces/product';
import { WishlistService } from '@services/wishlist.service';
import { CompareService } from '@services/compare.service';
import { QuickviewService } from '@services/quickview.service';
import { RootService } from '@services/root.service';
import { CurrencyService } from '@services/currency.service';
import { Subject } from 'rxjs';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '@app/_services/authentication.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
    UntypedFormControl,
    FormsModule,
    ReactiveFormsModule
} from '@angular/forms';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { CustomHttpUrlEncodingCodec, TranslateHelper } from '@app/_helpers';
import { Router, RouterLink } from '@angular/router';
import { AskVendorComponent } from '../ask-vendor/ask-vendor.component';
import { Support } from '@app/_helpers';
import {
    ViewportScroller,
    NgIf,
    NgClass,
    NgFor,
    DecimalPipe
} from '@angular/common';
import { environment } from '@environments/environment';
import { DirectionService } from '@app/_services/direction.service';
import { CurrencyFormatPipe } from '../../pipes/currency-format.pipe';
import { SVGLoaderComponent } from '../../../_components/svg-loader/svg-loader.component';
import { MatIconModule } from '@angular/material/icon';
import { InputNumberNewComponent } from '../input-number-new/input-number-new.component';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { ClickDirective } from '../../directives/click.directive';
import { MatButtonModule } from '@angular/material/button';
import { CurrencyConvertPipe } from '@app/shared/pipes';
import { SharedService } from '@app/_services/shared.service';

@Component({
    selector: 'app-product-card-new',
    templateUrl: './product-card-new.component.html',
    styleUrls: ['./product-card-new.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [
        NgIf,
        ClickDirective,
        RouterLink,
        NgClass,
        ExtendedModule,
        InputNumberNewComponent,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        NgFor,
        SVGLoaderComponent,
        DecimalPipe,
        TranslateModule,
        CurrencyFormatPipe,
        MatButtonModule,
        CurrencyConvertPipe
    ]
})
export class ProductCardNewComponent implements OnInit {
    constructor(
        public root: RootService,
        public cart: CartService,
        public direction: DirectionService,
        public wishlist: WishlistService,
        public compare: CompareService,
        public quickview: QuickviewService,
        public currency: CurrencyService,
        private toastr: ToastrService,
        private authenticationService: AuthenticationService,
        private modalService: BsModalService,
        private scroller: ViewportScroller,
        public translate: TranslateService,
        public translateHelper: TranslateHelper,
        private router: Router,
        private sharedService: SharedService
    ) {}

    private destroy$: Subject<void> = new Subject();

    @Input() template: any;
    @Input() tag: any;

    @Input() product: any;
    @Input() layout:
        | 'grid'
        | 'grid-sm'
        | 'grid-nl'
        | 'grid-lg'
        | 'list'
        | 'horizontal'
        | 'card-2'
        | 'card-3'
        | 'custom'
        | null = null;

    addingToCart = false;
    addingToCompare = false;
    isRTL = this.direction.isRTL();

    showingQuickview = false;
    featuredAttributes: ProductAttribute[] = [];
    imageKey;
    image = 'assets/images/nologo.png';
    userDetails;
    discountedPrice;
    discountedRate;
    vendorLink;
    sortBy = Support.sortBy;

    modalRef: BsModalRef;

    @ViewChild('modal', { read: TemplateRef }) modalTemplate: TemplateRef<any>;

    amount = new UntypedFormControl(1);
    isQuotable;
    addToCartAndQuotation;
    openSheet: boolean = false;
    area;
    propertyType;

    // Shipping availability
    canShipToUserCountry = true;

    checkIfQuotation() {
        if (this.product.minQuotationAmount == 0) {
            this.isQuotable = false;
            this.addToCartAndQuotation = false;
        } else if (
            this.product.minQuotationAmount > 0 &&
            !this.product.allowAddToCartWithQuotation
        ) {
            this.isQuotable = true;
            this.addToCartAndQuotation = false;
        } else if (
            this.product.minQuotationAmount > 0 &&
            this.product.allowAddToCartWithQuotation
        ) {
            this.isQuotable = true;
            this.addToCartAndQuotation = true;
        }
    }
    ///view add to cart button or if false show View item button
    ///item must be of type product not service and has no options, Moreover
    ///must not be quotable
    viewAddtoCart() {
        //if(this.product.type == 'product' && !this.product.options) && !(this.isQuotable && !this.addToCartAndQuotation)

        //return this.product.type == 'product' && !this.product.options && !(this.isQuotable && !this.addToCartAndQuotation);

        if (this.product.isOfferable) {
            return false;
        }

        if (this.product.type == 'product' && !this.product.options)
            if (this.isQuotable) {
                return this.addToCartAndQuotation;
            } else {
                return true;
            }
        return false;
    }

    whatsapp;
    canAddToCart = false;
    properties;
    ngOnInit(): void {
        this.vendorLink = [
            `/${this.translate.currentLang}`,
            ...(this.product?.sector?.seo?.slug
                ? ['sector', this.product?.sector?.seo?.slug]
                : ''),
            'vendor',
            this.product?.companyData?.seo?.slug
        ];

        this.checkIfQuotation();
        this.canAddToCart = this.viewAddtoCart() && !this.product?.booking?.forBooking;

        if (this.product.layout == 'property') {
            /*        _.forEach(this.product?.subtype?.properties, (item) => {
                if (item.iconImg?.url) item.iconImg.url = encodeURI(item.iconImg?.url);
            }); */
            this.properties = _.cloneDeep(this.product.subtype?.properties);
            const areaIndex = _.findIndex(this.properties, ['name.en', 'Area']);
            if (areaIndex > -1) {
                this.area = _.cloneDeep(this.properties[areaIndex]);
                this.properties.splice(areaIndex, 1);
            }

            const propertyTypeIndex = _.findIndex(this.properties, [
                'name.en',
                'Property Type'
            ]);
            if (propertyTypeIndex > -1) {
                this.propertyType = _.cloneDeep(
                    this.properties[propertyTypeIndex]
                );
                this.properties.splice(propertyTypeIndex, 1);
            }

            const typeIndex = _.findIndex(this.properties, ['name.en', 'Type']);
            if (typeIndex > -1) {
                this.properties.splice(typeIndex, 1);
            }

            /*       <ng-container *ngFor="let property of product?.subtype?.properties">
            <div *ngIf="name?.en == 'Bedrooms' || property.name?.en == 'Bathrooms' || property.name?.en == 'Property size'" class="flex flex-row property items-center">
              */
        }

        this.userDetails = this.authenticationService.currentUserValue;

        // Check shipping availability
        this.checkShippingAvailability();

        let oldPrice = this.product.baseTaxedPrice
            ? this.product.baseTaxedPrice
            : this.product.price;
        if (oldPrice && oldPrice - this.product.taxedPrice) {
            this.discountedRate = _.round(
                ((oldPrice - this.product.taxedPrice || this.product.price) /
                    oldPrice) *
                    100,
                0
            );
        }
        this.image = 'assets/images/nologo.png';
        if (this.product?.images) {
            this.imageKey = Object.keys(this.product.images)[0]?.toString();
            this.image =
                this.product?.images?.[this.imageKey]?.thumb?.url ||
                this.product?.images[this.imageKey]?.url ||
                    'assets/images/nologo.png';
        }
        this.image = this.image
            .replace(/\(/g, '%28')
            .replace(/\)/g, '%29')
            .replace(/\ /g, '%20')
            .replace(/\'/g, '%27')
            .replace(/\"/g, '%22');

        if (this.product?.agentData?.whatsapp?.e164Number) {
            let codec = new CustomHttpUrlEncodingCodec();
            this.whatsapp = {
                url: environment.web + this.routerLinkString(),
                number: this.product.agentData?.whatsapp.e164Number.substring(
                    1
                ),
                text: codec.encodeKey(
                    `Hi, I'am interested in [ ${this.product.name.en} ] - [${
                        this.product.code
                    }] ${environment.web + this.router.url}`
                )
            };
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    addToCart(): void {
        if (!this.addingToCart) {
            this.addingToCart = true;

            this.cart
                .addItem(
                    { productId: this.product._id, amount: this.amount.value },
                    this.product
                )
                .subscribe(
                    response => {
                        if (response.code == 200) {
                            this.toastr.success(
                                `Product "${
                                    this.product.name[
                                        this.translate.currentLang
                                    ]
                                }" added to cart!`,
                                undefined
                            );
                            this.addingToCart = false;
                        } else this.addingToCart = false;
                    },
                    error => {
                        this.toastr.error('Error adding to cart.');
                        this.addingToCart = false;
                    }
                );
        }
    }

    estateInquiry(): void {
        if (!this.userDetails) {
            this.router.navigate(['/login'], {
                queryParams: {
                    returnUrl: this.router.routerState.snapshot.url
                }
            });
            return;
        }

        const initialState = {
            companyId: this.product.companyId,
            product: this.product,
            message: ''
        };

        this.modalRef = this.modalService.show(AskVendorComponent, {
            initialState,
            ignoreBackdropClick: true
        });

        this.modalRef.content.closeBtnName = 'Close';
    }

    showQuickview(): void {
        let initialState = { product: this.product };
        this.modalRef = this.modalService.show(this.modalTemplate, {
            initialState
        });
    }

    routerLinkString() {
        return [
            `/${this.translate.currentLang}`,
            ...(this.product?.sector?.seo?.slug
                ? ['sector', this.product?.sector?.seo?.slug]
                : ''),
            this.product?.layout && this.product?.layout != 'product'
                ? this.product?.layout
                : this.product?.type,
            this.product?.seo?.slug
        ];
    }

    scrollToTop() {
        this.scroller.scrollToPosition([0, 0]);
    }

    addToCompare(): void {
        if (this.addingToCompare) {
            return;
        }

        this.addingToCompare = true;
        this.compare
            .add({ productId: this.product._id })
            .subscribe(response => {
                this.addingToCompare = false;
                if (response.code == 200) {
                    this.toastr.success(
                        `Product "${this.product.name?.en}" added to compare!`
                    );
                }
            });
    }

    /**
     * Check if product can be shipped to user's selected country
     */
    checkShippingAvailability(): void {
        const userSelectedCountry = this.sharedService.selectedCountry;
        const productCountryId = this.product?.companyData?.contact?.address
            ?.countryId;

        if (!userSelectedCountry || !productCountryId) {
            this.canShipToUserCountry = true;
            return;
        }

        // Compare country IDs
        const userCountryId = userSelectedCountry._id || userSelectedCountry.id;
        const productCountryIdStr =
            typeof productCountryId === 'string'
                ? productCountryId
                : productCountryId?.toString();
        const userCountryIdStr =
            typeof userCountryId === 'string'
                ? userCountryId
                : userCountryId?.toString();

        this.canShipToUserCountry = productCountryIdStr === userCountryIdStr;
    }
}
